import { v4 as uuidv4 } from 'uuid';

export const UUID_LOCAL_STORAGE_KEY = 'FFF_pandora_uuid';

const getOptimizelyUUID = (): string => {
  const uuidFromLocalStorage = localStorage.getItem(UUID_LOCAL_STORAGE_KEY);
  if (!uuidFromLocalStorage) {
    localStorage.setItem(UUID_LOCAL_STORAGE_KEY, uuidv4());
  }
  return localStorage.getItem(UUID_LOCAL_STORAGE_KEY) || '';
};

export default getOptimizelyUUID;
